import React from "react";

const StaffHomePage = ()=>{
    return(
        <div>
            <h2>Staff Dashboard is under developing, will see the feature soon..</h2>
        </div>
    )
}
export default StaffHomePage;